import { Get, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/collaborate/item",
    data: data,
  });
};

export const GetData = async () => {
  return await Get({
    url: "/cooperation/user_list",
    data: {
      type: "institution",
    },
  }).then(data => {
    return data;
  });
};
